/**
 * Chọn câu nói — Prompt.md §20.
 *
 * Tách khỏi `AlertEngine` để câu chữ đổi được (thêm biến thể, đổi giọng điệu) mà không chạm vào
 * luật cooldown, và để §20 ("không cảnh báo theo hướng trách móc") có đúng một chỗ để kiểm tra.
 */

import { alertMessages } from "@studystraight/shared-config";
import type { AlertMessageKey, PostureIssueType } from "@studystraight/shared-types";

/**
 * Issue → key câu nói. Ánh xạ thẳng theo tên, nhưng đi qua hàm này thay vì dùng `issue` làm key
 * trực tiếp: `AlertMessageKey` còn có `GENERIC`/`EYE_BREAK`, và nếu sau này một issue cần nhiều
 * biến thể câu thì chỗ sửa nằm ở đây chứ không rải trong engine.
 */
export function messageKeyFor(issue: PostureIssueType): AlertMessageKey {
  return issue;
}

/** Câu tiếng Việt cho một key. Key thiếu → `GENERIC`, không bao giờ trả chuỗi rỗng. */
export function messageFor(key: AlertMessageKey): string {
  return alertMessages[key] ?? alertMessages.GENERIC;
}
